










































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import {
  minLenght,
  hasAtLeastNumber,
  hasAtLeastLetter
} from '@/utils/validationPassword';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import RulePassword from '@/componentsV2/molecules/RulePassword/RulePassword.vue';
import InviteMailBox from '@/componentsV2/molecules/InviteMailBox/InviteMailBox.vue';
import flagKeys from '../../../../constants/flagKeys';
import recaptchaRoutesKeys from '../../../../constants/recaptchaRoutesKeys';

export type AccountFormData = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  recaptcha?: string;
};

import segmentIo from '@/utils/segment.io';
import { EBusinessIdentify } from '@/models/segment.io';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    Input,
    InviteMailBox,
    RulePassword
  }
})
export default class AccountForm extends Vue {
  @Prop({ default: false }) showBackButton?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: () => ({}) }) defaultFormData?: Partial<AccountFormData>;
  @Prop({ default: false }) isInviteFlow?: boolean;
  @Prop({ default: 'Invitation was sent for' }) labelInvitation?: string;
  @Prop({ default: 'Create account' }) labelBtnSubmit?: string;

  failedRulesPassword: string[] = [];

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  form: AccountFormData = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    ...(this.defaultFormData && this.defaultFormData)
  };

  accountData = {
    firstName: '',
    lastName: '',
    email: ''
  };

  clearFailedRulesPassword() {
    if (this.flagRulesPassword && this.$refs.observer) {
      this.failedRulesPassword = [];
    }
    return;
  }

  get isPasswordLengthValid() {
    return minLenght(this.form.password);
  }

  get isPasswordNumberValid() {
    return hasAtLeastNumber(this.form.password);
  }

  get isPasswordLetterValid() {
    return hasAtLeastLetter(this.form.password);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get flagRulesPassword() {
    return this.flags.includes(flagKeys.enableRulesPassword);
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (this.flagRulesPassword) {
      if (
        !this.isPasswordLengthValid ||
        !this.isPasswordNumberValid ||
        !this.isPasswordLetterValid
      ) {
        const failedRules = formRef.fields.password.failedRules;
        this.failedRulesPassword = Object.keys(failedRules);
        return null;
      }
    }

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    segmentIo.identifyAnonymousUser({
      ...(this.form.firstName && {
        [EBusinessIdentify.FIRST_NAME]: this.form.firstName
      }),
      ...(this.form.lastName && {
        [EBusinessIdentify.LAST_NAME]: this.form.lastName
      }),
      ...(this.form.email && { [EBusinessIdentify.EMAIL]: this.form.email })
    });

    if (this.flags.includes(flagKeys.businessSignupCaptcha)) {
      this.form.recaptcha = await this.$recaptcha(
        recaptchaRoutesKeys.businessSignup
      );
    }
    this.$emit('submit', this.form);
  }

  handleBack() {
    this.$emit('back');
  }

  mounted() {
    setTimeout(() => {
      setFocusOnFirstInput();
    }, 200);
  }
}
